import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const Step3 = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { jobid } = useParams();
  const [job, setJob] = useState(null);
  const location = useLocation();
  const { title, selectedCategory, selectedIndustry, selectedStyle, description, price, flexible, deliveryDate, files } = location.state || {};

  const [loading, setLoading] = useState(false);
  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  // useEffect(() => {
  //   const fetchJobDetails = async () => {
  //     const authToken = localStorage.getItem("p@token");
  //
  //     try {
  //       const response = await fetch(
  //         `${BaseURL}/api/requestjob/getJobDetails/${jobid}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             "auth-token": authToken,
  //           },
  //         }
  //       );
  //
  //       if (response.ok) {
  //         const result = await response.json();
  //         setJob(result);
  //       } else {
  //         const errorResponse = await response.json();
  //         showAlert(
  //           errorResponse.message || "Error fetching job details",
  //           "danger"
  //         );
  //       }
  //     } catch (error) {
  //       showAlert("Network Error", "danger");
  //     }
  //   };
  //
  //   fetchJobDetails();
  // }, [jobid]);

  // if (!job) {
  //   return <p>Loading...</p>;
  // }

  // Ensure you are accessing the correct properties
  // const jobData = job.job || {}; // Handle if job is null or undefined
  const handleButtonClick = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("Title", title);
    formData.append("Category", selectedCategory);
    formData.append("Industry", selectedIndustry);
    formData.append("Styles", selectedStyle);
    formData.append("Description", description);
    formData.append("amount", price);
    formData.append("flexible", flexible);
    formData.append("DeliveryDate", deliveryDate);

    files.forEach((file) => {
      formData.append("Attachfile", file);
      formData.append("OrignalNames", file.name);
    });
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/requestjob/uploadData`, {
        method: "POST",
        headers: {
          "auth-token": authToken,
        },
        body: formData,
      });

      if (!response.ok) {
        showAlert("Failed to create job. Please try again.", "danger");
        setLoading(false);
      }
    } catch (error) {
      console.error("Network Error:", error);
      showAlert("Network error. Please try again.", "danger");
      setLoading(false);
    }
    setLoading(false);
    navigate("/user-dashboard/offers/job-requests"); // Redirect to the specified URL

  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={` rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4
        ${theme === "dark" ? "bg-black text-white" : "bg-white"}
`}
      >
        <h1 className={`font-semibold text-xl text-center  ${theme === "dark" && "text-white"}`}>Brief Summary</h1>
        <div className="flex flex-col gap-4">
          <div className="flex font-pop flex-col gap-2">
            <p className={`text-base text-lightGrey font-light
             ${theme === "dark" && "text-white"}`}>Title:</p>
            <h3 className="text-lg font-medium">{title}</h3>
          </div>
          <div className="flex font-pop flex-col gap-2">
            <p className={`text-base text-lightGrey font-light   ${theme === "dark" && "text-white"}`}>Description:</p>
            <p className="text-base font-normal">{description}</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <div className="flex font-pop flex-col gap-2">
              <p className={`text-base text-lightGrey font-light
               ${theme === "dark" && "text-white"}`}>Industry:</p>
              <p className="text-base font-normal">{selectedCategory}</p>
            </div>
            <div className="flex font-pop flex-col gap-2">
              <p className={`text-base text-lightGrey font-light  ${theme === "dark" && "text-white"}`}>Category:</p>
              <p className="text-base font-normal">{selectedStyle}</p>
            </div>
            <div className="flex font-pop flex-col gap-2">
              <p className={`text-base text-lightGrey font-light
               ${theme === "dark" && "text-white"}`}>Budget:</p>
              <p className="text-base font-normal">${price}</p>
            </div>
            <div className="flex font-pop flex-col gap-2">
              <p className={`text-base text-lightGrey font-light
               ${theme === "dark" && "text-white"}`}>
                Delivery by:
              </p>
              <p className="text-base font-normal">
                {new Date(deliveryDate).toLocaleDateString()}
              </p>
            </div>
          </div>

          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white
         ${theme === "dark" ? "hover:text-white" : " hover:text-black"}  `}
            onClick={handleButtonClick}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Submit and get matched'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step3;
